import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

export default function ReactNavigationListener() {
  const navigate = useNavigate();

  useEffect(() => {
    const handler = (event: any) => {
      const path = event?.detail?.path;
      if (path) {
        navigate(path);
      }
    };

    window.addEventListener("react-navigate", handler);

    return () => {
      window.removeEventListener("react-navigate", handler);
    };
  }, [navigate]);

  const location = useLocation();

  useEffect(() => {

    const primengStyles = document.querySelectorAll('[data-primeng-style-id]');
    if (location.pathname.startsWith("/usermgmt")) {
      primengStyles.forEach(style => {
        (style as HTMLStyleElement).disabled = false;
      });
      window.dispatchEvent(
        new CustomEvent("angular-navigate", {
          detail: location.pathname + location.search
        })
      );
    } else {
      primengStyles.forEach(style => {
        (style as HTMLStyleElement).disabled = true;
      });
    }

  }, [location.pathname, location.search]);

  return null;
}
